import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Box, makeStyles } from '@material-ui/core'
import DeleteOutline from '@material-ui/icons/DeleteOutline'
import clsx from 'clsx'
import React, { FC, MouseEventHandler } from 'react'

import colors from '../../../../listingColors'

const { defaultLight, defaultPrimary, buttonSecondary } = colors

const useStyles = makeStyles(() => ({
    deleteContainer: {
        height: pxToRem(36),
        width: pxToRem(34),
        backgroundColor: buttonSecondary,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: pxToRem(4),
        color: defaultLight,
        '&.disabled': {
            backgroundColor: defaultPrimary,
        },
    },
    cancelAdd: {
        '&:hover': {
            cursor: 'pointer',
        },
    },
}))

type Props = {
    onClick: MouseEventHandler
    disabled?: boolean
}

const DeleteButton: FC<Props> = ({ onClick, disabled }) => {
    const classes = useStyles()

    return (
        <Box
            className={classes.deleteContainer}
            onClick={onClick}
            role="button"
            data-testid="deleteProperty"
        >
            <DeleteOutline
                data-testid="deleteIcon"
                className={clsx(classes.cancelAdd, { disabled: !!disabled })}
            />
        </Box>
    )
}

export default DeleteButton
